module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAABMBAMAAABnmnFTAAAAIVBMVEUAAAAApeEApOEAqOMAouAApeIApOEAoeEAn98Ao+EAoOI90989AAAAC3RSTlMAMy0GHxkoFA8jCmmoMYwAAADXSURBVDjLXdK7FYJAAETRObuCSiT+NZIOsAPoQDuQDqQDtwPpADr1gK4sb8IbvGhUpeFWUk0whNkENpIlqCK4KaB6lhQRLEFNAMceHMEQwuqhB0tQQ3AhoLrTUCVYgkpC94ftF2LCnKBsBFRP8lVAPAKqe/kqoSRcCcsfrD0sCMoIdw+silWxKlbFqljNWc1ZzVEdwZ++DaqEGSEZ4KVxFaEmmB6eCqqEhKBqAFRvIRhCRLCA4fTFBBzBEKIeUH0LVYAjmPQhVAGWoJLQXQAxYU4QQQWh/QChoD09c7BOOQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/WZBankMin/sanjiao1.png
// module id = r4w8
// module chunks = 70